module.exports = __webpack_public_path__ + "img/mutualiteFrancaise.b910886f.png";